<template>
  <div :style="containerSize" class="mapContainer">
    <BackgroundBorder :polygonsArray="polygonsArray"></BackgroundBorder>
    <div class="baseMapContainer">
      <!-- 基础地图 -->
      <BaseMap
        :polygonsArray="polygonsArray"
        :width="baseConfig.width"
        :height="baseConfig.height"
        :mask="mask"
        :drillDown="drillDown"
      ></BaseMap>
      <!-- 前景灯光图 -->
      <img src="../../assets/light.png" class="preImage" />
    </div>
    <HeatMark
      :polygonsArray="polygonsArray"
      :heatMarkConfig="heatMarkConfig"
      :heatMarkData="heatMarkData"
      :legendConf="legendConf"
      :mapData="mapData"
    ></HeatMark>
    <Bubble
      :propertie="activeAreaPropertie"
      :bubbleData="bubbleData"
      :itemList="itemList"
    ></Bubble>
    <div v-if="adcodeArray.length > 1" class="backBtn" @click="backAction()">
      返回
    </div>
  </div>
</template>
<script>
import { geoCentroid } from "d3-geo";
import BackgroundBorder from "./BackgroundBorder";
import BaseMap from "./BaseMap";
import HeatMark from "./HeatMark";
import Bubble from "./Bubble";

export default {
  name: "BorderMapComponent",
  components: {
    BackgroundBorder,
    BaseMap,
    HeatMark,
    Bubble
  },
  props: [
    "baseConfig",
    "bubbleData",
    "heatMarkData",
    "heatMarkConfig",
    "areaCode",
    "legendConf",
    "mapData",
    "itemList",
    "mask",
    "drillDown"
  ],
  data: function() {
    return {
      features: [],
      adcodeArray: [],
      minLng: undefined,
      maxLng: undefined,
      minLat: undefined,
      maxLat: undefined,
      activeAreaPropertie: undefined
    };
  },
  computed: {
    containerSize: function() {
      return {
        width: this.baseConfig.width + "px",
        height: this.baseConfig.height + "px"
      };
    },
    polygonsArray: function() {
      let polygonsArray = [];
      this.features.forEach(feature => {
        let polygons = [];
        if (feature && feature.geometry) {
          const coordinates = feature.geometry.coordinates;
          coordinates.forEach(coordinate => {
            let points = ``;
            coordinate.forEach(lnglat => {
              const position = this.lnglatToScreen(lnglat[0], lnglat[1]);
              points = `${points} ${position[0]},${position[1]}`;
            });
            polygons.push(points);
          });
          if (feature && feature.geometry) {
            const centerLngLat = geoCentroid(feature);
            polygonsArray.push({
              geometryCenter: this.lnglatToScreen(
                centerLngLat[0],
                centerLngLat[1]
              ),
              ...feature.properties,
              polygons
            });
          }
        }
      });
      return polygonsArray;
    }
  },
  methods: {
    backAction: function() {
      this.adcodeArray.pop();
      const adcode = this.adcodeArray.pop();

      adcode &&
        this.getData({
          adcode: adcode
        });
    },
    setActiveArea: function(propertie) {
      this.activeAreaPropertie = propertie;
      if (propertie && propertie.adcode) {
        this.$emit("listeningMouseHovering", propertie.adcode);
      } else {
        this.$emit("listeningMouseHovering", undefined);
      }
    },
    // 获取地图数据
    getData: function(item) {
      this.$emit("listeningMapCilick", item.adcode);
      if (item && item.level === "district") return;
      if (item.adcode) {
        this.adcodeArray.push(item.adcode);
        fetch(`/area/${item.adcode}.json`)
          .then(response => {
            return response.json();
          })
          .then(mapJson => {
            this.features = mapJson.features;
            const mapRange = this.getGeoExtent(this.features);
            this.minLng = mapRange.minLng;
            this.maxLng = mapRange.maxLng;
            this.minLat = mapRange.minLat;
            this.maxLat = mapRange.maxLat;
          });
      }
    },
    // 计算数据的最大最小经纬度
    getGeoExtent(features) {
      let minLng = 180,
        maxLng = -180,
        minLat = 90,
        maxLat = -90;

      for (let feature of features) {
        if (feature.geometry && feature.geometry.type === "Polygon") {
          for (let points of feature.geometry.coordinates) {
            for (let point of points) {
              minLng = minLng < point[0] ? minLng : point[0];
              maxLng = maxLng > point[0] ? maxLng : point[0];
              minLat = minLat < point[1] ? minLat : point[1];
              maxLat = maxLat > point[1] ? maxLat : point[1];
            }
          }
        } else if (
          feature.geometry &&
          feature.geometry.type === "MultiPolygon"
        ) {
          for (let polygonPoints of feature.geometry.coordinates) {
            for (let points of polygonPoints) {
              for (let point of points) {
                minLng = minLng < point[0] ? minLng : point[0];
                maxLng = maxLng > point[0] ? maxLng : point[0];
                minLat = minLat < point[1] ? minLat : point[1];
                maxLat = maxLat > point[1] ? maxLat : point[1];
              }
            }
          }
        }
      }
      return {
        minLng,
        minLat,
        maxLng,
        maxLat
      };
    },
    // 经纬度到屏幕
    lnglatToScreen: function(lng, lat) {
      // 组件周围留出35空隙
      const width = this.baseConfig.width - 70;
      const height = this.baseConfig.height - 70;
      const middlePixelX = this.baseConfig.width / 2,
        middlePixelY = this.baseConfig.height / 2;

      const dLng = this.maxLng - this.minLng,
        dLat = this.maxLat - this.minLat;
      const cLng = (this.maxLng + this.minLng) / 2,
        cLat = (this.maxLat + this.minLat) / 2;

      const pixelPermeter =
        dLng / dLat > width / height ? width / dLng : height / dLat;
      return [
        middlePixelX + (lng - cLng) * pixelPermeter,
        middlePixelY + (cLat - lat) * pixelPermeter
      ];
    }
  },
  mounted: function() {
    this.getData({
      adcode: this.areaCode
    });
  }
};
</script>
<style scoped>
.mapContainer {
  position: relative;
  /* background-color: #081936; */
}

.baseMapContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.preImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: screen;
  pointer-events: none;
}

.backBtn {
  position: absolute;
  left: 0.3rem;
  top: 0rem;
  box-sizing: border-box;
  width: 0.88rem;
  height: 0.26rem;
  padding-left: 0.26rem;
  background: url(../../assets/backBtn.jpg);
  background-size: 100% 100%;
  color: #fff;
  font-size: 0.18rem;
  line-height: 0.27rem;
  cursor: pointer;
}
</style>
